import type { Notes } from "../../../../types";
import { formatNote } from "../../../../utils/formatNote";
import { reviewNotes } from "../../../../utils/review";

type RatingCriteriaProps = {
  notes?: Partial<Notes>;
  reviewsCount: number;
};

const RatingCriteria = ({ notes, reviewsCount }: RatingCriteriaProps) => {
  if (reviewsCount === 0) return null;

  const criteria = reviewNotes
    .map(({ label, name, Icon }) => ({
      label,
      name,
      Icon,
      note: notes?.[name as keyof Notes] ?? 0,
    }))
    .sort((a, b) => b.note - a.note);

  return (
    <div className="mt-10 w-full py-3">
      <div className="grid grid-cols-2 gap-x-5 gap-y-7 sm:grid-cols-3 lg:grid-cols-5">
        {criteria.map(({ label, name, Icon, note }) => (
          <div
            key={name}
            className="flex flex-col items-center gap-1.5 text-center"
          >
            <Icon className="size-6 shrink-0 text-muted-foreground" />
            <strong className="text-[38px] leading-[1.05] font-bold text-primary">
              {formatNote(note)}
            </strong>
            <span className="text-[13px] leading-tight font-medium">
              {label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RatingCriteria;
